import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import { Dialog, DialogContent, DialogTitle } from 'components/ui/dialog';

interface DeleteAccountProps {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export default function DeleteAccountDialog({
  open,
  isLoading,
  onClose,
  onDelete,
}: DeleteAccountProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className='max-w-md px-4 py-6 sm:p-8'
        onOpenAutoFocus={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        hideClose
      >
        <DialogTitle className='sr-only'>Delete Account</DialogTitle>

        <div className='space-y-6'>
          <div className='w-3/4 mx-auto'>
            <p className='text-lg font-medium leading-tight text-center'>
              {t('delete_account_confirmation')}
            </p>
          </div>

          <div className='flex justify-center gap-x-4'>
            <Button
              disabled={isLoading}
              size='sm'
              className='px-8 bg-neutral-400 hover:bg-neutral-400/80'
              onClick={onClose}
            >
              {t('cancel')}
            </Button>
            <Button
              disabled={isLoading}
              onClick={onDelete}
              size='sm'
              className='px-8 bg-rose-400 hover:bg-rose-400/80'
            >
              {isLoading && (
                <Loader2 className='mr-2 size-4 animate-spin' role='status' />
              )}
              {t('delete')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
